import { createAction, props } from "@ngrx/store"; // Action is an interface of type string
import { CourseMetrics } from "cli-types";

// ------ Load Course Metrics ------
export const loadCourseMetrics = createAction(
    "[CourseMetrics] Load Course Metrics",
    props<{ courseID: number; studentID: number }>()
);
export const loadCourseMetricsFail = createAction(
    "[CourseMetrics] Load Course Metrics Fail",
    props<{ payload: any }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCourseMetricsSuccess = createAction(
    "[CourseMetrics] Load Course Metrics Success",
    props<{ payload: CourseMetrics }>()
);
// ----- Clear Store
export const clearCourseMetricsStore = createAction(
    "[CourseMetrics] Clear Course Metrics Store"
);
